var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsToggleHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 20.5H11C8.48369 20.4895 6.07344 19.4852 4.29412 17.7059C2.5148 15.9266 1.51053 13.5163 1.5 11V11C1.51053 8.48369 2.5148 6.07344 4.29412 4.29412C6.07344 2.5148 8.48369 1.51053 11 1.5H37C39.5163 1.51053 41.9266 2.5148 43.7059 4.29412C45.4852 6.07344 46.4895 8.48369 46.5 11V11C46.4895 13.5163 45.4852 15.9266 43.7059 17.7059C41.9266 19.4852 39.5163 20.4895 37 20.5V20.5Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15C13.7091 15 15.5 13.2091 15.5 11C15.5 8.79086 13.7091 7 11.5 7C9.29086 7 7.5 8.79086 7.5 11C7.5 13.2091 9.29086 15 11.5 15Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 46.5H37C39.5163 46.4895 41.9266 45.4852 43.7059 43.7059C45.4852 41.9266 46.4895 39.5163 46.5 37V37C46.4895 34.4837 45.4852 32.0734 43.7059 30.2941C41.9266 28.5148 39.5163 27.5105 37 27.5H11C8.48369 27.5105 6.07344 28.5148 4.29412 30.2941C2.5148 32.0734 1.51053 34.4837 1.5 37V37C1.51053 39.5163 2.5148 41.9266 4.29412 43.7059C6.07344 45.4852 8.48369 46.4895 11 46.5V46.5Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 41C38.7091 41 40.5 39.2091 40.5 37C40.5 34.7909 38.7091 33 36.5 33C34.2909 33 32.5 34.7909 32.5 37C32.5 39.2091 34.2909 41 36.5 41Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsToggleHorizontal);
export default __webpack_public_path__ + "static/media/settings-toggle-horizontal.3212f9c09c29f3304e332cb77b413bc8.svg";
export { ForwardRef as ReactComponent };